import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { Link } from "react-router-dom";
import * as Icons from "react-feather";
import { ReactComponent as SortArrow } from '../../../shared/img/chevron-up-down.svg';

const ClientSettingsEdit = ({ show, onClose, settings = [], loading, onRefresh, onUpdate, error }) => {
  const [editId, setEditId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [saving, setSaving] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [filterText, setFilterText] = useState('');

  const startEdit = (setting) => {
    setEditId(setting.ClientSettingsId);
    setEditValue(setting.Value || '');
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setEditId(null);
    setEditValue('');
    setSaving(false);
  };

  const saveEdit = async () => {
    if (!editId) return;
    setSaving(true);
    await onUpdate(editId, editValue || '');
    setSaving(false);
    setEditModalOpen(false);
    setEditId(null);
    setEditValue('');
  };

  const columns = [
    { name: 'Type', selector: row => row.SettingType, sortable: true, wrap: true, width: '22%' },
    { name: 'Parameter', selector: row => row.SettingParameter, sortable: true, wrap: true, width: '25%' },
    {
      name: 'Value',
      grow: 2,
      cell: (row) => (
        <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{row.Value}</div>
      )
    },
    {
      name: 'Actions',
      width: '140px',
      cell: (row) => (
        <div className="edit-delete-action">
          <Link
            className="me-2 p-2"
            to=""
            onClick={() => startEdit(row)}
          >
            <Icons.Edit data-feather="edit" className="feather-edit" />
          </Link>
        </div>
      )
    }
  ];

  const filteredSettings = (settings || []).filter((item) => {
    const term = (filterText || '').toLowerCase();
    if (!term) return true;
    const type = (item.SettingType || '').toLowerCase();
    const param = (item.SettingParameter || '').toLowerCase();
    const val = (item.Value || '').toLowerCase();
    return type.includes(term) || param.includes(term) || val.includes(term);
  });

  return (
    <>
    <Modal show={show} onHide={onClose} size="lg" backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Client Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="search-set">
            <div className="search-input">
              <button type="button" className="btn btn-searchset" onClick={(e) => e.preventDefault()}>
                <Icons.Search className="feather-search" />
              </button>
              <input
                type="text"
                className="form-control form-control-sm custom-search-input"
                placeholder="Search"
                aria-label="Search Input"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
          </div>
        </div>
        <DataTable
          columns={columns}
          data={filteredSettings}
          progressPending={loading}
          noDataComponent={<div className="py-3">No settings found.</div>}
          dense
          persistTableHead
          highlightOnHover
          striped
          sortIcon={<SortArrow />}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>

    <Modal show={editModalOpen} onHide={closeEditModal} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Setting Value</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2 text-muted" style={{ fontSize: '13px' }}>
          Update the value for the selected setting.
        </div>
        <textarea
          className="form-control"
          rows={4}
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          autoFocus
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeEditModal}>Cancel</Button>
        <Button variant="primary" onClick={saveEdit} disabled={saving}>{saving ? 'Saving…' : 'Save'}</Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default ClientSettingsEdit;
